var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import TuneIcon from "@mui/icons-material/Tune";
import { PitchIcon } from "../teams/formation/PitchIcon";
import { Avatar, Box, Button, Card, CardContent, CardHeader, Divider, Grid, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AddActivityMenu } from "../activity/AddActivityMenu";
import { useRetrieveTeamFeed } from "../api/FeedApiProivder";
import { useListAggregatedPlayerStatsByTeam } from "../api/StatsApiProvider";
import { useListTeamHomeVenues } from "../api/TeamVenueApiProvider";
import { useClaimTeamOwnership, useDeleteTeam, useRetrievePlayerByUserId, useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveTeamPreferences, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { Feed } from "../feed/Feed";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { PlayerListRow } from "../players/PlayerListRow";
import { StatsStack } from "../stats/StatsStack";
import { aggregatePlayerStats } from "../stats/utils";
import { AssistantManagersCard } from "../teams/AssistantManagersCard";
import { SquadCard } from "../teams/SquadCard";
import { TeamColorsCircle } from "../teams/TeamColors";
import { TransferRequestButton } from "../transfer/TransferRequestButton";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { ResponsiveActionMenu, } from "../utils/ResponsiveActionMenu";
import { useNumericParams } from "../utils/useNumericParams";
import { VenuesCard } from "../venues/VenuesCard";
var Team = function () {
    var _a;
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _b = __read(useState(false), 2), showDelete = _b[0], setShowDelete = _b[1];
    var _c = __read(useState(false), 2), showClaimConfirm = _c[0], setShowClaimConfirm = _c[1];
    var _d = __read(useState(false), 2), deleteLoading = _d[0], setDeleteLoading = _d[1];
    var _e = useRetrieveUserTeamPermissions({ teamId: id }), userTeamPermissions = _e.data, userTeamPermissionsIsLoading = _e.isLoading, userTeamPermissionsError = _e.error;
    var _f = userTeamPermissions || {}, _g = _f.canModify, canModify = _g === void 0 ? false : _g, _h = _f.canView, canView = _h === void 0 ? false : _h, _j = _f.canViewManager, canViewManager = _j === void 0 ? false : _j, _k = _f.canSubmitTransferRequest, canSubmitTransferRequest = _k === void 0 ? false : _k, _l = _f.canClaimOwnership, canClaimOwnership = _l === void 0 ? false : _l;
    var _m = useRetrieveTeam({ id: id, enabled: canView }), isTeamLoading = _m.isLoading, error = _m.error, team = _m.data;
    var _o = useRetrievePlayerByUserId({
        userId: (team === null || team === void 0 ? void 0 : team.manager) ? Number(team.manager) : undefined,
        enabled: canViewManager && !!(team === null || team === void 0 ? void 0 : team.manager),
    }), isManagerLoading = _o.isLoading, managerError = _o.error, manager = _o.data;
    var _p = useRetrieveTeamFeed({
        team: team,
        limit: isMobile ? 5 : 10,
    }), teamFeed = _p.data, teamFeedIsLoading = _p.isLoading, teamFeedError = _p.error, fetchNextPage = _p.fetchNextPage, hasNextPage = _p.hasNextPage, isFetchingNextPage = _p.isFetchingNextPage;
    var _q = useListAggregatedPlayerStatsByTeam({ teamId: id }), aggregatedStats = _q.data, aggregatedStatsIsLoading = _q.isLoading, aggregatedStatsError = _q.error;
    var filteredAggregatedStats = useMemo(function () {
        if (!aggregatedStats)
            return [];
        return aggregatePlayerStats(aggregatedStats, {
            years: [],
            types: [],
        });
    }, [aggregatedStats]);
    var _r = useRetrieveTeamPreferences({ teamId: id }), teamPreferencesIsLoading = _r.isLoading, teamPreferencesError = _r.error, teamPreference = _r.data;
    var _s = useListTeamHomeVenues({
        teamId: id,
        enabled: canView,
    }), isTeamVenuesLoading = _s.isLoading, teamVenuesError = _s.error, teamVenues = _s.data;
    var _t = useRetrievePlayersByTeamId({ teamId: id }), playersIsLoading = _t.isLoading, playersError = _t.error, players = _t.data;
    var mutation = useDeleteTeam({
        id: id,
        onMutate: function () {
            setDeleteLoading(true);
        },
        onSuccess: function () {
            navigate("/teams/");
        },
        onError: function () { return setDeleteLoading(false); },
    });
    var claimMutation = useClaimTeamOwnership({
        id: id,
        onSuccess: function () { return setShowClaimConfirm(false); },
        onError: function () { return setShowClaimConfirm(false); },
    });
    var isLoading = (isTeamLoading && canView) ||
        isTeamVenuesLoading ||
        deleteLoading ||
        teamFeedIsLoading ||
        playersIsLoading ||
        teamPreferencesIsLoading ||
        aggregatedStatsIsLoading ||
        (isManagerLoading && canViewManager && !!(team === null || team === void 0 ? void 0 : team.manager));
    var handleDelete = function () {
        mutation.mutate();
    };
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (teamVenuesError) {
        return _jsx(ErrorView, { error: teamVenuesError });
    }
    if (!canView) {
        return _jsx(Forbidden, {});
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error ||
        playersError ||
        teamPreferencesError ||
        aggregatedStatsError ||
        players === undefined ||
        teamFeedError ||
        managerError ||
        !teamFeed ||
        !team ||
        !teamPreference) {
        return _jsx(ErrorView, { error: error });
    }
    if (teamVenues === undefined) {
        return _jsx(ErrorView, { error: "Failed to load team venues." });
    }
    if (id === undefined) {
        return _jsx(NotFound, {});
    }
    var headerActions = __spreadArray([
        {
            icon: _jsx(PitchIcon, {}),
            label: "Build Formation",
            to: "/teams/".concat(id, "/formation/"),
        }
    ], __read((canModify
        ? [
            {
                icon: _jsx(SwapHorizIcon, {}),
                label: "Transfer Ownership",
                to: "/teams/".concat(id, "/ownership-invitations"),
            },
            {
                icon: _jsx(MailOutlineIcon, {}),
                label: "Invitations",
                to: "/teams/".concat(id, "/invitations"),
            },
            { icon: _jsx(EditIcon, {}), label: "Edit Team", to: "/teams/".concat(id, "/edit/") },
            {
                icon: _jsx(TuneIcon, {}),
                label: "Preferences",
                to: "/teams/".concat(team.id, "/preferences/edit/"),
            },
            {
                icon: _jsx(DeleteIcon, {}),
                label: "Delete Team",
                onClick: function () { return setShowDelete(true); },
            },
        ]
        : [])), false);
    var activitySection = (_jsxs(Box, { children: [_jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", sx: { mb: 1 }, children: [_jsx(Typography, { variant: "h6", children: "Latest Activity" }), canModify && _jsx(AddActivityMenu, { teamId: team.id })] }), _jsx(Feed, { feed: teamFeed, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isFetchingNextPage: isFetchingNextPage })] }));
    var statsCard = _jsx(StatsStack, { stats: filteredAggregatedStats });
    var squadCard = (_jsx(SquadCard, { players: players, teamId: team.id, canModify: canModify }));
    var managerCard = (_jsxs(_Fragment, { children: [canViewManager && manager && (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", children: "Manager" }), _jsx(Divider, { sx: { marginBottom: 2 } }), _jsx(PlayerListRow, { player: manager })] }) })), team.manager === null && (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", children: "Manager" }), _jsx(Divider, { sx: { marginBottom: 2 } }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: canClaimOwnership || canModify ? 2 : 0 }, children: "No manager assigned" }), _jsxs(Stack, { spacing: 1, children: [canClaimOwnership && (_jsx(Button, { variant: "outlined", size: "small", fullWidth: true, startIcon: _jsx(EditIcon, {}), onClick: function () { return setShowClaimConfirm(true); }, disabled: claimMutation.isLoading, children: claimMutation.isLoading ? "Claiming…" : "Claim as Manager" })), canModify && (_jsx(Link, { to: "/teams/".concat(id, "/ownership-invitations"), style: { textDecoration: "none" }, children: _jsx(Button, { variant: "outlined", size: "small", fullWidth: true, startIcon: _jsx(SwapHorizIcon, {}), children: "Invite a Manager" }) }))] })] }) }))] }));
    var assistantCard = (_jsx(AssistantManagersCard, { teamId: id, assistantManagerIds: (_a = team === null || team === void 0 ? void 0 : team.assistantManagers) !== null && _a !== void 0 ? _a : [], canModify: canModify }));
    var venuesCard = (_jsx(VenuesCard, { venues: teamVenues.filter(function (tv) { return tv.isActive; }).map(function (tv) { return tv.venue; }), canModify: canModify, title: "Home Stadiums", manageUrl: "/teams/".concat(id, "/venues/") }));
    var colorsCard = (_jsxs(Card, { children: [_jsx(CardHeader, { title: _jsx(Typography, { variant: "h6", children: "Team Colors" }) }), _jsxs(CardContent, { children: [_jsx(Divider, { sx: { marginBottom: 2 } }), _jsxs(Stack, { spacing: 2, alignItems: "center", children: [_jsx(Box, { sx: {
                                    width: "100%",
                                    maxWidth: 150,
                                    aspectRatio: "1",
                                    borderRadius: "50%",
                                    border: "2px solid",
                                    borderColor: "divider",
                                    overflow: "hidden",
                                    boxShadow: 1,
                                }, children: _jsx(TeamColorsCircle, { color1: team.primaryColour, color2: team.secondaryColour }) }), _jsxs(Stack, { direction: "row", spacing: 4, justifyContent: "center", children: [_jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [_jsx(Box, { sx: {
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: "4px",
                                                    bgcolor: team.primaryColour,
                                                    border: "1px solid",
                                                    borderColor: "divider",
                                                } }), _jsx(Typography, { variant: "caption", children: "Primary" })] }), _jsxs(Stack, { spacing: 0.5, alignItems: "center", children: [_jsx(Box, { sx: {
                                                    width: 24,
                                                    height: 24,
                                                    borderRadius: "4px",
                                                    bgcolor: team.secondaryColour,
                                                    border: "1px solid",
                                                    borderColor: "divider",
                                                } }), _jsx(Typography, { variant: "caption", children: "Secondary" })] })] })] })] })] }));
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete team. Please try again.", onClose: function () { } }), _jsx(ErrorSnackbar, { open: claimMutation.isError, message: "Failed to claim team ownership. Please try again.", onClose: function () { } }), _jsx(DeleteDialog, { open: showDelete, title: "Delete ".concat(team.name, "?"), onCancel: function () { return setShowDelete(false); }, onConfirm: handleDelete }), _jsx(DeleteDialog, { open: showClaimConfirm, title: "Claim Team Ownership?", titleColor: "primary.main", description: "As manager you'll control this team's roster, matches, and settings. Other members will see you listed as the manager.", confirmText: "Claim Ownership", confirmColor: "primary", onCancel: function () { return setShowClaimConfirm(false); }, onConfirm: function () { return claimMutation.mutate(); } }), _jsx(Card, { sx: { mb: 3 }, children: _jsx(CardHeader, { avatar: _jsx(Avatar, { sx: { width: 56, height: 56 }, src: team.logo || "", alt: team.name }), title: _jsx(Typography, { variant: "h5", component: "div", children: team.name }), subheader: _jsxs(Typography, { variant: "caption", fontStyle: "italic", children: [team.nickname, " EST \u2022 ", team.establishedYear] }), action: _jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [canSubmitTransferRequest && (_jsx(TransferRequestButton, { team: team })), _jsx(ResponsiveActionMenu, { actions: headerActions, isMobile: isMobile })] }) }) }), isMobile ? (_jsxs(Stack, { spacing: 2, children: [activitySection, squadCard, statsCard, managerCard, assistantCard, venuesCard, colorsCard] })) : (
            // Desktop: unchanged 3-column layout.
            _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, md: 3, children: statsCard }), _jsx(Grid, { item: true, md: 6, children: activitySection }), _jsx(Grid, { item: true, md: 3, children: _jsxs(Stack, { spacing: 2, children: [squadCard, managerCard, assistantCard, venuesCard, colorsCard] }) })] }))] }));
};
export default Team;
